import React, { Component } from 'react';
import Spinner from 'react-spinkit';

import { filter } from '../../helpers/filter';

import './userMessage.css'

class UserMessage extends Component {

  render() {
    return(

      <div className="user-row">

        <div className="user-message drop-shadow" onClick={() => this.props.onClick && this.props.onClick()}>
          {this.props.fieldInput.length > 0
            ? <div><Spinner name="ball-pulse-sync" fadeIn="none" className="user-spinner"/></div>
            : <div><p>{filter.clean(this.props.message)}</p></div>
          }
        </div>

        {this.props.companyLogo.length > 0 &&
          <div className="user-avatar-company-logo">
            <img
              src={`${this.props.companyLogo}`}
              alt=""
              style={{width: '100%'}}
            />
          </div>
        }

        {this.props.companyLogo.length === 0 &&
          <div className="user-avatar">
            {this.props.companyName.charAt(0).toUpperCase()}
          </div>
        }

      </div>


    )
  }
}

export default UserMessage
